import { render, staticRenderFns } from "./Guide2.vue?vue&type=template&id=6467d74d&"
import script from "./Guide2.vue?vue&type=script&lang=js&"
export * from "./Guide2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports